<template>
    <div class="transfer-files-personal" v-if="!isLoading">
        <div class="accordion mb-2" id="accordionFilesPersonalQualifications">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseQualifications"
                        aria-expanded="false"
                        aria-controls="collapseQualifications"
                    >Kwalificaties</button>
                </h2>
                <div
                    id="collapseQualifications"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFilesPersonalQualifications"
                >
                    <div class="accordion-body px-0">
                        <div class="list-group list-group-flush">
                            <div class="list-group-item d-none d-md-block bg-body-tertiary border-0">
                                <div class="list-group list-group-flush">
                                    <div class="list-group-item d-flex align-items-center me-4 py-0 bg-body-tertiary">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col offset-6">Startdatum</div>
                                                <div class="col">Verloopt op</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list-group-item">
                                <div
                                    class="list-group list-group-flush"
                                    v-bind:key="key" v-for="(qualification, key) in qualifications"
                                >
                                    <div class="list-group-item fw-bold">
                                        {{ qualification.name }}
                                    </div>
                                    <div
                                        class="list-group-item d-flex justify-content-between align-items-center"
                                        v-bind:key="rKey" v-for="(record, rKey) in qualification.records"
                                    >
                                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                            <div class="container-fluid">
                                                <div class="row">
                                                    <div class="col-12 col-md-6 text-truncate">{{ record.name }}</div>
                                                    <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ record.start_date }}</div>
                                                    <div class="col-auto p-0 mobile-font-muted mobile-font-small d-block d-md-none">t/m</div>
                                                    <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ record.end_date }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <span @click="downloadFile('qualification', record.name, record.id, record.isGroup)">
                                                <icon name="download" :fontSize="'1.5rem'"></icon>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="accordion mb-2" id="accordionFilesPersonalDocuments">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseDocuments"
                        aria-expanded="false"
                        aria-controls="collapseDocuments"
                    >Documenten</button>
                </h2>
                <div
                    id="collapseDocuments"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFilesPersonalDocuments"
                >
                    <div class="accordion-body">
                        <div class="list-group list-group-flush">
                            <div class="list-group-item d-none d-md-block bg-body-tertiary border-0">
                                <div class="list-group list-group-flush">
                                    <div class="list-group-item d-flex align-items-center me-4 py-0 bg-body-tertiary">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col offset-6">Datum gewijzigd</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="list-group-item d-flex justify-content-between align-items-center"
                                v-bind:key="key" v-for="(document, key) in documents"
                            >
                                <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-12 col-md-6 text-truncate">{{ document.name }}</div>
                                            <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ document.modified_at }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <span @click="downloadFile('document', document.name, document.hash)">
                                        <icon name="download" :fontSize="'1.5rem'"></icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="accordion mb-2" id="accordionFilesPersonalPayouts">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsePayouts"
                        aria-expanded="false"
                        aria-controls="collapsePayouts"
                    >Betaalspecificatie</button>
                </h2>
                <div
                    id="collapsePayouts"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFilesPersonalPayouts"
                >
                    <div class="accordion-body">
                        <div class="list-group list-group-flush">
                            <div class="list-group-item d-none d-md-block me-4 bg-body-tertiary border-0">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-3">Batchnummer</div>
                                        <div class="col-3">Datum</div>
                                        <div class="col-3">Bedrag</div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="list-group-item d-flex justify-content-between align-items-center"
                                v-bind:key="key"
                                v-for="(payout, key) in payouts"
                            >
                                <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-12 col-md-3 mobile-font-bold">
                                                <span class="d-md-none">Batchnummer</span>
                                                {{ payout.idEuroCollect }}
                                            </div>
                                            <div class="col-12 col-md-3">
                                                {{ this.$moment(payout.executeDate).format("DD-MM-YYYY") }}
                                            </div>
                                            <div class="col-12 col-md-3">
                                                {{
                                                    parseFloat(payout.amount).toLocaleString("nl-NL", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <span @click="handleOpenModal(payout.idEuroCollect)">
                                        <icon name="look-into" :fontSize="'1.5rem'"></icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="alert alert-info" role="alert" v-if="isLoading">
        Laden...
    </div>

    <modal v-if="showModal">
        <template v-slot:header>
            <h3 class="modal-title">
                Betaalspecificatie details
            </h3>
        </template>
        <template v-slot:body>
            <div style="padding: 5px; padding-top: 0; max-height: calc(100vh - 200px); overflow-y: auto;">
                <div v-if="isModalLoading" class="text-center">
                    Laden...
                </div>
                <div v-else-if="modalData">
                    <div class="table-responsive">
                        <table class="table">
                            <thead class="font-weight-bold">
                                <tr>
                                    <th>Verzorger</th>
                                    <th>Kind</th>
                                    <th>IBAN</th>
                                    <th>Periode</th>
                                    <th>Bedrag</th>
                                    <th>Vergoedingsoverzicht</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, keyRow) in modalData.flatMap(payout => payout.rows)" :key="keyRow">
                                    <td>{{ row.isInvoiceLine ? row.invoiceLineDescription : row.carerFullName }}</td>
                                    <td>{{ !row.isInvoiceLine ? row.childFullName : '' }}</td>
                                    <td>{{ row.ibanGastouder }}</td>
                                    <td>{{ row.period }}</td>
                                    <td>{{ parseFloat(row.amount).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                                    <td>{{ row.number }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else>
                    Geen gegevens gevonden voor deze betaalspecificatie.
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div>
                <button class="btn btn-outline-info" @click="handleCloseModal">Sluiten</button>
            </div>
        </template>
    </modal>
</template>

<script>
import Icon from '@/components/Icon'
import Modal from '@/components/Modal'

export default {
    name: 'TransferFilesPersonal',
    components: {
        Icon,
        Modal
    },
    data() {
        return {
            isLoading: false,
            qualifications: [],
            documents: [],
            payouts: [],
            showModal: false,
            isModalLoading: false,
            modalData: null
        }
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
    },
    created() {
        window.novict = {
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
        this.isLoading = true
        this.getQualifications()
        this.getDocuments()
        this.getPayouts()
        this.isLoading = false
    },
    methods: {
        fetchModalData(idEuroCollect) {
            this.isModalLoading = true;
            const queryString = this.$store.getters.selectedGroupsQueryString;
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request
                .get(`/payout-details/${queryString}/${idEuroCollect}`)
                .then((response) => {
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (response) {
                        this.modalData = response.payouts;
                    }
                    this.isModalLoading = false
                });
        },

        handleOpenModal(idEuroCollect) {
            this.showModal = true;
            this.fetchModalData(idEuroCollect);
        },

        handleCloseModal() {
            this.showModal = false;
            this.modalData = null;
        },
        getQualifications() {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-qualifications/' + this.$store.getters.selectedGroupsQueryString).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.qualifications = response.qualifications
                }
            })
        },
        getDocuments() {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-documents').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.documents = response.documents
                }
            })
        },
        getPayouts() {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-payouts/' + this.$store.getters.selectedGroupsQueryString).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.payouts = response.payouts
                }
            })
        },

        downloadFile(resource, filename, id, isGroup = false) {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post('/download-personal-'+ resource, {
                file: id,
                isGroup: isGroup
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response && response.fileContent !== null) {
                    var docUrl = document.createElement('a')
                    docUrl.href = "data:application/octet-stream;base64," + response.fileContent
                    docUrl.setAttribute('download', filename)
                    document.body.appendChild(docUrl)
                    docUrl.click()
                } else {
                    alert('Er is een fout opgetreden tijdens het downloaden. Probeer later opnieuw')
                }
            })
        },
    }
}
</script>

<style scoped>
.accordion-button:not(.collapsed) {
    color: #082F4D;
    background-color: #f2f9ff;
    box-shadow: none;
}
.accordion-body {
    padding: .5rem;
}

@media only screen and (max-width: 720px) {
    .mobile-font-muted {
        color: #6c757d;
    }
    .mobile-font-bold {
        font-weight: bold;
    }
    .mobile-font-small {
        font-size: .875rem;
    }
}
</style>